import React, { useState, useEffect } from "react";
import {
    Breadcrumb,
    Col,
    Row,
    Card,
    Tab,
    Nav,
    Badge
} from "@themesberg/react-bootstrap";
import Preloader from "../../components/Preloader";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { TnosDataTable } from "../../components/TnosDataTable";

export default () => {
    const [getDataResponder, setDataResponder] = useState([]);
    const [getDataInsiden, setDataInsiden] = useState([]);
    const [getDataUser, setDataUser] = useState([]);

    const [getMessageEmptyData, setMessageEmptyData] = useState(
        "Belum ada transaksi pada hari ini"
    )

    const location = useLocation()
    const member_account_code = location.pathname.split("/")[3];

    const getResponder = () => {
        fetch(`${process.env.REACT_APP_API_TAB_ORGANISASI}/account/responder/${member_account_code}/admin`)
            .then((res) => res.json())
            .then((response) => {

                setDataResponder(response.data)

            }).catch((error) => {
                toast(error)
            });
    }

    const getUser = () => {
        fetch(`${process.env.REACT_APP_API_TAB_ORGANISASI}/account/user/${member_account_code}/admin`)
            .then((res) => res.json())
            .then((response) => {

                setDataUser(response.data)

            }).catch((error) => {
                toast(error)
            });
    }

    const getInsiden = () => {
        fetch(`${process.env.REACT_APP_API_TAB_ORGANISASI}/panic_report/${member_account_code}/show_organization`)
            .then((res) => res.json())
            .then((response) => {
                setDataInsiden(response.data)
            }).catch((error) => {
                toast(error)
            });
    }

    useEffect(() => {
        getResponder();
        getUser();
        getInsiden();
    }, []);

    const TableRow = (props) => {
        const {
            detail,
            num
        } = props;

        return (
            <tr>
                <td className="text-center">{num}.</td>
                <td>{detail?.nama}</td>
                <td className="text-center">{detail?.phone_number}</td>
                <td>{detail?.username}</td>
                <td className="text-center">{detail?.account_status_id}</td>
                <td className="text-center">{detail?.nama_institusi}</td>
            </tr>
        );
    }

    const TableRowUser = (props) => {
        const {
            detail,
            num
        } = props;

        return (
            <tr>
                <td className="text-center">{num}.</td>
                <td>{detail?.nama}</td>
                <td className="text-center">{detail?.phone_number}</td>
                <td>{detail?.username}</td>
                <td className="text-center">{detail?.account_status_id}</td>
            </tr>
        );
    }

    const TableRowInsiden = (props) => {
        const {
            nama,
            jam,
            phone_number,
            responder_name,
            responder_phone_number,
            status,
            tanggal,
            num
        } = props;

        return (
            <tr>
                <td className="text-center">{num}.</td>
                <td>{nama}</td>
                <td className="text-center">{phone_number}</td>
                <td className="text-center">{jam}</td>
                <td>{responder_name ? responder_name : '-' }</td>
                <td className="text-center">{responder_phone_number ? responder_phone_number : '-' }</td>
                <td className="text-center">{tanggal}</td>
                <td className="text-center">
                    {status === "Selesai" ? (
                        <>
                            <Badge bg="success" className="badge-lg">
                                Selesai
                            </Badge>
                        </>
                    ) : status === "Menunggu Responder" ? (
                        <>
                            <Badge bg="warning" className="badge-lg">
                                Menunggu Responder
                            </Badge>
                        </>
                    ) : status === "Sedang Ditangani" ? (
                        <>
                            <Badge bg="primary" className="badge-lg">
                                Sedang Ditangani
                            </Badge>
                        </>
                    ) : "-" }
                </td>
            </tr>
        );
    }

    return (
        <>
            <Row>
                <Preloader show={!getDataResponder ? true : false} />
                <Row className="mt-4"></Row>
                <Breadcrumb
                    className="d-none d-md-inline-block"
                    listProps={{
                        className: "breadcrumb-dark breadcrumb-transparent",
                    }}
                >
                    <Breadcrumb.Item href="/pwa-b2b/order">
                        Data Akun
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>Detail Akun External</Breadcrumb.Item>
                </Breadcrumb>
                <Tab.Container defaultActiveKey="akun_external_responder">
                    <Row>
                        <Col lg={12}>
                            <Nav className="nav-tabs">
                                <Nav.Item>
                                    <Nav.Link eventKey="akun_external_responder">Responder</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="akun_external_user">User</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="akun_internal_insiden">Insiden</Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Col>
                        <Col lg={12}>
                            <Tab.Content>
                                <Tab.Pane eventKey="akun_external_responder">
                                    <Card border="light">
                                        <Card.Body>
                                            <TnosDataTable
                                                data={
                                                    <>
                                                        <thead className="thead-light" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                                                            <tr>
                                                                <th className="border-0 text-center">No.</th>
                                                                <th className="border-0">Nama</th>
                                                                <th className="border-0">Nomor HP</th>
                                                                <th className="border-0">Username</th>
                                                                <th className="border-0 text-center">Status</th>
                                                                <th className="border-0 text-center">Org</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {getDataResponder?.length > 0 ? (
                                                                getDataResponder?.map((td, index) => (
                                                                    <TableRow
                                                                        key={`order-success-${td.id}`}
                                                                        {...td}
                                                                        num={index + 1}
                                                                    />
                                                                ))
                                                            ) : (
                                                                <tr className="text-center">
                                                                    <td colSpan={8}>{getMessageEmptyData}</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </>
                                                }
                                            ></TnosDataTable>
                                        </Card.Body>
                                    </Card>
                                </Tab.Pane>

                                <Tab.Pane eventKey="akun_external_user">
                                    <Card border="light">
                                        <Card.Body>
                                            <TnosDataTable
                                                data={
                                                    <>
                                                        <thead className="thead-light" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                                                            <tr>
                                                                <th className="border-0 text-center">No.</th>
                                                                <th className="border-0">Nama</th>
                                                                <th className="border-0">Nomor HP</th>
                                                                <th className="border-0">Username</th>
                                                                <th className="border-0 text-center">Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {getDataUser?.length > 0 ? (
                                                                getDataUser?.map((td, index) => (
                                                                    <TableRowUser
                                                                        key={`order-success-${td.id}`}
                                                                        {...td}
                                                                        num={index + 1}
                                                                    />
                                                                ))
                                                            ) : (
                                                                <tr className="text-center">
                                                                    <td colSpan={8}>{getMessageEmptyData}</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </>
                                                }
                                            ></TnosDataTable>
                                        </Card.Body>
                                    </Card>
                                </Tab.Pane>

                                <Tab.Pane eventKey="akun_internal_insiden">
                                    <Card border="light">
                                        <Card.Body>
                                            <TnosDataTable
                                                data={
                                                    <>
                                                        <thead className="thead-light" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                                                            <tr>
                                                                <th className="border-0 text-center">No.</th>
                                                                <th className="border-0">Nama</th>
                                                                <th className="border-0 text-center">Nomor HP</th>
                                                                <th className="border-0 text-center">Jam</th>
                                                                <th className="border-0">Nama Responder</th>
                                                                <th className="border-0 text-center">Nomor HP Responder</th>
                                                                <th className="border-0 text-center">Tanggal</th>
                                                                <th className="border-0 text-center">Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {getDataInsiden?.length > 0 ? (
                                                                getDataInsiden?.map((td, index) => (
                                                                    <TableRowInsiden
                                                                        key={`order-success-${td.id}`}
                                                                        {...td}
                                                                        num={index + 1}
                                                                    />
                                                                ))
                                                            ) : (
                                                                <tr className="text-center">
                                                                    <td colSpan={8}>{getMessageEmptyData}</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </>
                                                }
                                            ></TnosDataTable>
                                        </Card.Body>
                                    </Card>
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </Row>
        </>
    );
};
